module.exports = __webpack_public_path__ + "img/top.20e372a6.png";